<template>
    <aside class="ks-right-drawer" :class="[rightDrawerClasses]">
        <div class="ks-right-drawer-backdrop" v-show="showBackdrop"></div>
        <div class="ks-right-drawer-menu">
            <span style="cursor:pointer; position:absolute; z-index: 10; top: 5px; left: 20px;"
                v-show="ksRightDrawerConfig.showCloseIcon"
                @click.prevent="closeRightDrawer"
            >
                <!--<i class="fa fa-times" aria-hidden="true"></i>-->
                <i class="fas fa-angle-right"></i>
            </span>
            <slot></slot>
        </div>
    </aside>
</template>

<script>
import config from '@/config'
export default {
    /**
        tag
        name: ks-right-drawer
        description: rich-right-drawer
    **/
    name: '',
    props:{
        /**
            attribute
            name: screenSize 
            description: screenSize
        **/
        screenSize:{
            type: String,
            required: true
        },
        /**
            attribute
            name: screenSizeId 
            description: screenSizeId
        **/
        screenSizeId:{
            type: Number,
            required: true
        }
    },
    watch: {
        '$route.path': function (path){
            document.body.classList.remove(`ks-body-margin-right-drawer`);
        },
        ksRightDrawerConfig: {
            handler: function(val){
                this.changeRightDrawerConfig();
            },
             deep: true
        },
        screenSizeId: function(size, oldSize){
            this.changeRightDrawerConfig();
        },
    },
    computed:{
        rightDrawerClasses() {
            try {
                let CustomClasses = config.layout && config.layout.rightDrawer && config.layout.rightDrawer.classes && Array.isArray(config.layout.rightDrawer.classes) ? config.layout.rightDrawer.classes.join(' ') : '';
                return `${CustomClasses}`;
            } catch (err) {
                return '';
            }
        },
    },
    mounted(){
        /* Right Drawer  */
        this.ksRightDrawer = document.querySelector(".ks-right-drawer");
        this.ksRightDrawerBackdrop = document.querySelector(".ks-right-drawer-backdrop");
        this.ksRightDrawerMenu = document.querySelector(".ks-right-drawer-menu");
        this.ksRightDrawer.addEventListener("transitionend", this.OnTransitionRightDrawerEnd, false);
        this.ksRightDrawerBackdrop.addEventListener("click", this.toggleRightDrawer, false);
        //add functions to global app var
        app.openRightDrawer=this.openRightDrawer;
        app.closeRightDrawer=this.closeRightDrawer;
        app.toggleRightDrawer=this.toggleRightDrawer;
        app.setRightDrawerConfig=this.setRightDrawerConfig;
        app.rightDrawerStatus=this.rightDrawerStatus;
    },
    methods:{
        setRightDrawerConfig(config){
            let aux = JSON.parse(JSON.stringify(this.ksRightDrawerConfig));
            if(config!==null && typeof config == 'object'){
                aux.pushContent = config.pushContent!=undefined?config.pushContent:false;
                aux.showCloseIcon = config.showCloseIcon!=undefined?config.showCloseIcon:false;
                this.ksRightDrawerConfig = aux;
            }
            this.rightDrawerStatus.pushContent = this.ksRightDrawerConfig.pushContent;
            this.rightDrawerStatus.showCloseIcon = this.ksRightDrawerConfig.showCloseIcon;
        },
        changeRightDrawerConfig(){
            document.body.classList.remove(`ks-body-margin-right-drawer`);
            this.ksRightDrawer.classList.remove(`ks-right-drawer-margin`);
            if(this.screenSizeId > 3){
                if(this.ksRightDrawerConfig.pushContent!==undefined && this.ksRightDrawerConfig.pushContent===true){
                    if(this.rightDrawerStatus.isOpen ){
                        document.body.classList.add(`ks-body-margin-right-drawer`);
                        this.ksRightDrawer.classList.add(`ks-right-drawer-margin`); 
                    }
                    this.showBackdrop=false;
                }
            }else{
               this.showBackdrop=true; 
            }
        },
        toggleRightDrawer() {
            if(this.rightDrawerStatus.isOpen){
               this.closeRightDrawer();
            }else{
                this.openRightDrawer();
            }  
        },
        openRightDrawer(config = null) {
            this.setRightDrawerConfig(config);
            if(this.ksRightDrawerConfig.pushContent && this.screenSizeId > 3){
                document.body.classList.add(`ks-body-margin-right-drawer`);
                this.ksRightDrawer.classList.add(`ks-right-drawer-margin`);
            }  
            if(!this.ksRightDrawer.classList.contains("ks-right-drawer--visible")){
                this.ksRightDrawer.classList.add("menu--animatable");     
                this.ksRightDrawer.classList.add("ks-right-drawer--visible");
            }
            this.rightDrawerStatus.isOpen = true;
        },
        closeRightDrawer() {
            if(this.ksRightDrawerConfig.pushContent){
                document.body.classList.remove(`ks-body-margin-right-drawer`);
                this.ksRightDrawer.classList.remove(`ks-right-drawer-margin`);
            }  
            if(this.ksRightDrawer.classList.contains("ks-right-drawer--visible")){ 
                this.ksRightDrawer.classList.add("menu--animatable");      
                this.ksRightDrawer.classList.remove('ks-right-drawer--visible');
            }
            this.rightDrawerStatus.isOpen = false;  
        },
        OnTransitionRightDrawerEnd() {
            this.ksRightDrawer.classList.remove("menu--animatable");
        }
    },
    data(){
        return{
            ksRightDrawer:{},
            ksRightDrawerBackdrop:{},
            ksRightDrawerMenu:{},
            showBackdrop: true,
            ksRightDrawerConfig:{
                pushContent: true,
                showCloseIcon: true
            },
            rightDrawerStatus:{
                isOpen: false,
                pushContent: false,
                showCloseIcon: true
            }
        }
    }
}
</script>

<style>
 /* Right Drawer classes */
    .ks-right-drawer {
	    position: fixed;
	    right: 0;
	    top: 0;
	    width: 100%;
	    height: 100%;
	    overflow: hidden;
	    pointer-events: none;
	    z-index: 110;
	}

	.ks-right-drawer--visible {
	    pointer-events: none;
	}

	.ks-right-drawer-menu {
	    background-color: #fff;
	    position: absolute;
        right:0px;
	    max-width: 400px;
	    width: 100%;
	    height: 100%;
	    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
	    -webkit-transform: translateX(103%);
	            transform: translateX(103%);
	    display: flex;
	    flex-direction: column;
	    will-change: transform;
	    z-index: 160;
	    pointer-events: auto; 
        overflow: hidden;           
	}

	.ks-right-drawer--visible .ks-right-drawer-menu {
	    -webkit-transform: none;
	            transform: none;
	}

	.ks-right-drawer--animatable .ks-right-drawer-menu {
	    transition: all 130ms ease-in;
	}

	.ks-right-drawer--visible.ks-right-drawer--animatable  .ks-right-drawer-menu {
	    transition: all 330ms ease-out;
	}

	.ks-right-drawer-backdrop {
	    content: '';
	    display: block;
	    position: absolute;
	    right: 0;
	    top: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,0.4);
	    opacity: 0;
	    will-change: opacity;
	    pointer-events: none;
	    transition: opacity 0.3s cubic-bezier(0,0,0.3,1);
	}

	.ks-right-drawer--visible .ks-right-drawer-backdrop {
	    opacity: 1;
	    pointer-events: auto;
	}

    .ks-body-margin-right-drawer{
        margin-right: 400px;
    }
    
    .ks-right-drawer-margin{
       margin-top: 55px; 
    }
</style>
